module.exports = __webpack_public_path__ + "media/images/categoryIcons/economy_icon-216a869befabf1a278571ad8d3e1ddf6.svg";